import { Dialog } from './Dialog';
import { MOD } from './platform';

const GROUPS: readonly { title: string; items: readonly [string, string][] }[] = [
  {
    title: 'Tools',
    items: [
      ['Select', 'V'],
      ['Rectangle', 'R'],
      ['Ellipse', 'O'],
      ['Diamond', 'D'],
      ['Arrow', 'A'],
      ['Line', 'L'],
      ['Freehand', 'P'],
      ['Text', 'T'],
      ['Eraser', 'E'],
      ['Pan', 'H or hold Space'],
      ['Keep tool after drawing', 'Q'],
    ],
  },
  {
    title: 'Editing',
    items: [
      ['Delete selection', 'Delete'],
      ['Undo', `${MOD}+Z`],
      ['Redo', `${MOD}+Shift+Z`],
      ['Cut / Copy / Paste', `${MOD}+X / C / V`],
      ['Duplicate', `${MOD}+D`],
      ['Select all', `${MOD}+A`],
      ['Nudge', 'Arrow keys'],
      ['Nudge further', 'Shift + Arrows'],
      ['Edit text of selection', 'Enter'],
      ['Bring to front / send to back', '] / ['],
      ['Deselect or cancel', 'Escape'],
    ],
  },
  {
    title: 'View and files',
    items: [
      ['Zoom in / out', `${MOD}+= / ${MOD}+-`],
      ['Zoom to 100%', `${MOD}+0`],
      ['Zoom to fit', 'Shift+1'],
      ['Pan', 'Space + drag, or scroll'],
      ['Export as SVG', `${MOD}+Shift+S`],
      ['Export as PNG', `${MOD}+Shift+P`],
      ['Export as JSON', `${MOD}+S`],
      ['Board contents panel', `${MOD}+/`],
      ['This dialog', '?'],
    ],
  },
];

export function ShortcutsDialog({ onClose }: { readonly onClose: () => void }) {
  return (
    <Dialog
      title="Keyboard shortcuts"
      onClose={onClose}
      footer={
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Close
        </button>
      }
    >
      <div className="shortcut-grid">
        {GROUPS.map((group) => (
          <section key={group.title}>
            <h3>{group.title}</h3>
            <dl>
              {group.items.map(([label, keys]) => (
                <div key={label} style={{ display: 'contents' }}>
                  <dt>{label}</dt>
                  <dd>
                    <kbd>{keys}</kbd>
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
      <div className="prose" style={{ marginTop: 16 }}>
        <p>
          Shapes can also be reached without a pointer: open the board contents panel, pick an element,
          then nudge, resize or edit it from the keyboard.
        </p>
      </div>
    </Dialog>
  );
}
